import { Link } from "@tanstack/react-router"
import { CardDescription, CardTitle } from "design-system/molecules/Card"
import { useForgotPasswordMutation } from "modules/auth/hooks/useForgotPasswordMutation"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ForgotPasswordSchema } from "schema"
import { z } from "zod"
import { AuthWrapper } from "../AuthWrapper"
import { ForgotPasswordForm } from "./ForgotPasswordForm"

export const ForgotPassword = () => {
  const { t } = useTranslation()
  const [isRequested, setIsRequested] = useState<boolean>(false)
  const { mutateAsync, isPending } = useForgotPasswordMutation()

  const onSubmitSignup = async (data: z.infer<typeof ForgotPasswordSchema>) => {
    await mutateAsync(data)
    setIsRequested(true)
  }

  return (
    <AuthWrapper>
      <div className="flex flex-col gap-4 w-full justify-center items-center">
        {isRequested ? (
          <div className="flex flex-col gap-4 mb-4 items-center text-center text-xl">
            <CardTitle>{t("auth.forgotPassword.success.title")}</CardTitle>
            <CardDescription>{t("auth.forgotPassword.success.body")}</CardDescription>
          </div>
        ) : (
          <ForgotPasswordForm onSubmit={onSubmitSignup} isPending={isPending} />
        )}
        <Link to="/login" className="text-xs underline hover:text-foreground/80">
          {t("auth.forgotPassword.goToLogin")}
        </Link>
      </div>
    </AuthWrapper>
  )
}
